<template>
  <span>
    <!-- シナリオブループリント -->
    <svg class="svg" :width="width" :height="height" :viewBox="viewport" @wheel="zoom">
      <ConnectPathStore v-for="(s1, i) in scenarioTable" :key="i" :scenario="s1"/>
      <ScenarioGroupStore v-for="(s2, i) in scenarioTable" :key="`A-${i}`" :scenario="s2" :ratio="ratio" :dx="dx" :dy="dy"/>
      <DescribeStore v-for="(s3, i) in selectScenarioList" :key="`B-${i}`" :scenario="s3['scenario']"/>
    </svg>
    <!-- シナリオブループリント -->
    <!-- <transition name="fade">
      <svg class="svg-map" :width="width/30" :height="height/30" :viewBox="viewportMap" v-if="isMiniMap">
        <rect fill="white" :x="mapX" :y="mapY" :width="width/6.1*ratio" :height="height/7.5*ratio" :rx="rxSize"></rect>
        <ConnectPath v-for="(s3, i) in scenarioTable" :key="`B-${i}`" :scenario="s3"></ConnectPath>
        <ScenarioGroup v-for="(s4, i) in scenarioTable" :key="`C-${i}`" :scenario="s4" :ratio="ratio" :dx="dx" :dy="dy"></ScenarioGroup>
      </svg>
    </transition> -->
  </span>
</template>

<script>
import { mapState } from 'vuex'
import ConnectPathStore from '@/views/DashBoard/ChatBot/ConnectPathStore'
import ScenarioGroupStore from '@/views/DashBoard/ChatBot/ScenarioGroupStore'
import DescribeStore from '@/views/DashBoard/ChatBot/DescribeStore'
export default {
  name: 'BluePrintStore',
  componentName: 'BluePrintStore',
  components: {
    ConnectPathStore,
    ScenarioGroupStore,
    DescribeStore
  },
  computed: {
    ...mapState('chatbot', ['scenarioTable', 'selectScenarioList', 'editAreaRatio'])
  },
  mounted () {
    console.debug('*** Start *** mounted')
    this.$store.dispatch('chatbot/selectScenarioList', {flg: false, scenario: null})
    this.$store.dispatch('chatbot/getEditAreaRatio')
    this.ratio = 1.55
    this.makeViewBox(this.dx, this.dy, this.width * this.ratio, this.height * this.ratio)
    console.debug('*** End *** mounted')
  },
  watch: {
    scenarioTable () {
      this.$store.dispatch('chatbot/getEditAreaRatio')
    },
    editAreaRatio () {
      if (this.editAreaRatio > this.ratio) {
        // 計算した倍率が1.55を超える場合はscenarioTableに合わせて広げる
        // そのまま掛けると更に1.55倍されるので75%に倍率を下げて掛ける
        const alignRatio = this.editAreaRatio * 0.75
        this.width = Math.floor(this.width * alignRatio)
        this.height = Math.floor(this.height * alignRatio)
      } else {
        // 計算した倍率が1.55を超えなければそのまま
        this.width = 5000
        this.height = 4000
      }
      this.makeViewBox(this.dx, this.dy, this.width * this.ratio, this.height * this.ratio)
    }
  },
  methods: {
    zoom (e) {
      console.debug('*** Start *** zoom')
      console.debug('e: ' + JSON.stringify(e))
      if (this.scenarioTable.length == 0) return
      var [x, y, w, h] = this.viewport.split(' ').map(v => parseFloat(v))
      if (e.ctrlKey) {
        if (e.deltaY > 0) {
          w = w * 1.01
          h = h * 1.01
        } else {
          w = w * 0.99
          h = h * 0.99
        }
        this.makeViewBox(x, y, w, h)
        this.ratio = w / this.width
        localStorage.setItem('ratio_' + this.scenarioTable[0].name, this.ratio)
        e.preventDefault()
      } else {
        // 画面移動
        // if ((this.dx + e.deltaX > -200 && this.dy + e.deltaY > -200) &&
        //     (this.dx + e.deltaX < 5200 && this.dy + e.deltaY < 5200)) {
        //   this.makeViewBox(x + e.deltaX, y + e.deltaY, w, h)
        //   this.dx += e.deltaX
        //   this.dy += e.deltaY
        //   this.mapX += e.deltaX
        //   this.mapY += e.deltaY
        //   localStorage.setItem('dx_' + this.scenarioTable[0].name, this.dx)
        //   localStorage.setItem('dy_' + this.scenarioTable[0].name, this.dy)
        // }
        console.info('none')
      }
      console.debug('*** End *** zoom')
    },
    zoomBtn (d) {
      console.debug('*** Start *** zoomBtn')
      console.debug('d: ' + JSON.stringify(d))
      if (this.scenarioTable.length == 0) return
      var [x, y, w, h] = this.viewport.split(' ').map(v => parseFloat(v))
      w = w * d
      h = h * d
      this.viewport = [x, y, w, h].join(' ')
      this.ratio = w / this.width
      localStorage.setItem('ratio_' + this.scenarioTable[0].name, this.ratio)
      console.debug('*** End *** zoomBtn')
    },
    makeViewBox (x, y, w, h) {
      console.debug('*** Start *** makeViewBox')
      console.debug('x: ' + JSON.stringify(x))
      console.debug('y: ' + JSON.stringify(y))
      console.debug('w: ' + JSON.stringify(w))
      console.debug('h: ' + JSON.stringify(h))
      this.viewport = [x, y, w, h].join(' ')
      console.debug('*** End *** makeViewBox')
    },
    changeMiniMapFlg () {
      console.debug('*** Start *** changeMiniMapFlg')
      this.isMiniMap = !this.isMiniMap
      localStorage.setItem('isMiniMap_' + this.scenarioTable[0].name, this.isMiniMap)
      console.debug('*** End *** changeMiniMapFlg')
    },
    getIsMiniMap () {
      console.debug('*** Start *** getIsMiniMap')
      return this.isMiniMap
    }
  },
  data () {
    return {
      rxSize: 15,
      width: 5000,
      height: 4000,
      ratio: 1,
      dx: 0,
      dy: 0,
      mapX: 0,
      mapY: 0,
      isMouseDown: false,
      isMouseUp: false,
      isMiniMap: true,
      viewport: '0 0 5000 4000',
      viewportMap: '0 0 5000 4000'
    }
  }
}
</script>

<style scoped>
.svg {
  background-color: #f9f9f9;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='100' height='100' viewBox='0 0 100 100'%3E%3Cg fill-rule='evenodd'%3E%3Cg fill='%2392aca4' fill-opacity='0.62'%3E%3Cpath opacity='.5' d='M96 95h4v1h-4v4h-1v-4h-9v4h-1v-4h-9v4h-1v-4h-9v4h-1v-4h-9v4h-1v-4h-9v4h-1v-4h-9v4h-1v-4h-9v4h-1v-4h-9v4h-1v-4H0v-1h15v-9H0v-1h15v-9H0v-1h15v-9H0v-1h15v-9H0v-1h15v-9H0v-1h15v-9H0v-1h15v-9H0v-1h15v-9H0v-1h15V0h1v15h9V0h1v15h9V0h1v15h9V0h1v15h9V0h1v15h9V0h1v15h9V0h1v15h9V0h1v15h9V0h1v15h4v1h-4v9h4v1h-4v9h4v1h-4v9h4v1h-4v9h4v1h-4v9h4v1h-4v9h4v1h-4v9h4v1h-4v9zm-1 0v-9h-9v9h9zm-10 0v-9h-9v9h9zm-10 0v-9h-9v9h9zm-10 0v-9h-9v9h9zm-10 0v-9h-9v9h9zm-10 0v-9h-9v9h9zm-10 0v-9h-9v9h9zm-10 0v-9h-9v9h9zm-9-10h9v-9h-9v9zm10 0h9v-9h-9v9zm10 0h9v-9h-9v9zm10 0h9v-9h-9v9zm10 0h9v-9h-9v9zm10 0h9v-9h-9v9zm10 0h9v-9h-9v9zm10 0h9v-9h-9v9zm9-10v-9h-9v9h9zm-10 0v-9h-9v9h9zm-10 0v-9h-9v9h9zm-10 0v-9h-9v9h9zm-10 0v-9h-9v9h9zm-10 0v-9h-9v9h9zm-10 0v-9h-9v9h9zm-10 0v-9h-9v9h9zm-9-10h9v-9h-9v9zm10 0h9v-9h-9v9zm10 0h9v-9h-9v9zm10 0h9v-9h-9v9zm10 0h9v-9h-9v9zm10 0h9v-9h-9v9zm10 0h9v-9h-9v9zm10 0h9v-9h-9v9zm9-10v-9h-9v9h9zm-10 0v-9h-9v9h9zm-10 0v-9h-9v9h9zm-10 0v-9h-9v9h9zm-10 0v-9h-9v9h9zm-10 0v-9h-9v9h9zm-10 0v-9h-9v9h9zm-10 0v-9h-9v9h9zm-9-10h9v-9h-9v9zm10 0h9v-9h-9v9zm10 0h9v-9h-9v9zm10 0h9v-9h-9v9zm10 0h9v-9h-9v9zm10 0h9v-9h-9v9zm10 0h9v-9h-9v9zm10 0h9v-9h-9v9zm9-10v-9h-9v9h9zm-10 0v-9h-9v9h9zm-10 0v-9h-9v9h9zm-10 0v-9h-9v9h9zm-10 0v-9h-9v9h9zm-10 0v-9h-9v9h9zm-10 0v-9h-9v9h9zm-10 0v-9h-9v9h9zm-9-10h9v-9h-9v9zm10 0h9v-9h-9v9zm10 0h9v-9h-9v9zm10 0h9v-9h-9v9zm10 0h9v-9h-9v9zm10 0h9v-9h-9v9zm10 0h9v-9h-9v9zm10 0h9v-9h-9v9z'/%3E%3Cpath d='M6 5V0H5v5H0v1h5v94h1V6h94V5H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E");
}
.svg-map {
  position: absolute;
  left: 0;
  bottom: 0;
  opacity: 0.75;
  border: solidthin #ccc;
  border-radius: 5px;
  background-color: #666;
}
.fade-enter-active, .fade-leave-active {
  transition: opacity .6s;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/views/DashBoard/ChatBot/BluePrintStore.vue